import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-1 text-xs text-red-500"
}
const _hoisted_2 = ["disabled"]

import { reactive, watch } from 'vue'
import Modal from '@/components/layout/Modal.vue'

interface Draft {
  firstName: string
  lastName: string
  username: string
  dateOfBirth: string
  gender: string
  address: string
  city: string
  state: string
  zipcode: string
  phone: string
  email: string
}

const emailError = 'Email is required.'

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileEmailModal',
  props: {
    isOpen: { type: Boolean },
    draft: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Create a local reactive copy of the draft
const localDraft = reactive<Draft>({ ...props.draft })

// Watch for changes in props.draft and update localDraft
watch(() => props.draft, (newDraft) => {
  Object.assign(localDraft, newDraft)
}, { deep: true })

const handleSave = () => {
  emit('save', { ...localDraft })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "model-value": __props.isOpen,
    title: "Edit Email",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-primary to-secondary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60",
        disabled: __props.loading,
        onClick: handleSave
      }, " Save ", 8, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "mb-1 block text-xs font-semibold text-slate-700" }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localDraft.email) = $event)),
          type: "email",
          class: "w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40 border border-slate-200/60 dark:border-slate-700/60 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-slate-900 focus:ring-[#ff8e48]/60"
        }, null, 512), [
          [_vModelText, localDraft.email]
        ]),
        (!localDraft.email)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(emailError)))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})